import { combineEpics } from "redux-observable";
import "./views/Search/epics/index.js";
import { rootEpic as rootEpic$1 } from "./views/Search/epics/epics.js";
const rootEpic = combineEpics(rootEpic$1);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
